import {
  CHECKTRAIL_REPORT_SEND,
  GET_S2_LINK,
  CHECK_FIX_OPR,
  FILE_UPLOAD_VERIFY,
  ADD_UPLOADED_FILES,
  UPDATE_UPLOAD_PROGRESS,
  CLEAR_UPLOAD_PROGRESS,
  UPDATED_FILE,
  VIEW_SUMMARY_LINK,
  MYDOCUMENTS_WIP,
  MYDOCUMENTS_ERROR,
  VALIDATION_REPORT_SENT,
  DOWNLOAD_VALIDATION_REPORT,
} from '../actions/CheckTrailActions'

const initialState = {
  data: {},
  uploadProgress: {},
  uploadedFiles: [],
}

const CheckTrailReducer = function (state = initialState, action) {
  switch (action.type) {
    case CHECKTRAIL_REPORT_SEND:
      state = {
        ...state,
        data: action.payload?.data,
      }
      break

    case FILE_UPLOAD_VERIFY:
      console.log('Upload Verify:', action.payload)
      state = {
        ...state,
        fileUploadVerifyResponse: action.payload,
      }
      break

    case VIEW_SUMMARY_LINK:
      console.log('Summary Link', action.payload?.data)
      state = {
        ...state,
        viewSummary: action.payload?.data,
      }
      break

    case GET_S2_LINK:
      state = {
        ...state,
        uploadCred: action.payload,
      }
      break

    case UPDATED_FILE:
      state = {
        ...state,
        updatedRecord: action.payload.data,
        updatedRecordStatus: action.payload.success,
      }
      break
    case CHECK_FIX_OPR:
      state = {
        ...state,
        checkFixMsg: action.payload,
      }
      break

    case ADD_UPLOADED_FILES:
      state = {
        ...state,
        uploadedFiles: action.payload,
      }
      break
    case UPDATE_UPLOAD_PROGRESS:
      state = {
        ...state,
        uploadProgress: { ...state.uploadProgress, ...action.payload },
      }
      break
    case CLEAR_UPLOAD_PROGRESS:
      state = {
        ...state,
        uploadedFiles: [],
        uploadProgress: {},
      }
      break

    case MYDOCUMENTS_WIP:
      state = {
        ...state,
        myDocsWip: action.payload?.data,
        myDocsCount: action.payload?.totalCount,
      }
      break

    case MYDOCUMENTS_ERROR:
      state = {
        ...state,
        myDocsError: action.payload?.data,
      }
      break
    case VALIDATION_REPORT_SENT:
      state = {
        ...state,
        validationReportMailRes: action.payload,
      }
      break
    case DOWNLOAD_VALIDATION_REPORT:
      state = {
        ...state,
        downloadMessage: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}
export default CheckTrailReducer
